module.exports = __webpack_public_path__ + "media/events/event1-7579ac4e.jpg";